/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import { TYPE_COMPONENT_BY_TYPE_ACTE } from '@/constants';

import InformationsActe from './InformationsActe';
import InformationsEnfant from './InformationsEnfant';

const StepActeNaissance = () => {
  const { data, onChange, errors, selectedTypeActe } =
    React.useContext(AssistantContext);

  /** Tranche d'erreurs propre à cette étape (clés = `name` des champs) */
  const errorsStep = errors?.[Steps.Acte] ?? {};

  const typeComponent = selectedTypeActe
    ? TYPE_COMPONENT_BY_TYPE_ACTE[selectedTypeActe]
    : undefined;

  return (
    <div
      className="assistant-step-acte"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsActe data={data} errors={errorsStep} onChange={onChange} />
      <InformationsEnfant
        data={data}
        errors={errorsStep}
        onChange={onChange}
        typeComponent={typeComponent}
      />
    </div>
  );
};

export default StepActeNaissance;
